import { Outlet } from 'react-router'
import { SidebarProvider, SidebarInset } from '@/components/shadcn/sidebar'
import { AppSidebar } from './AppSidebar'
import { AppHeader } from './app-header/AppHeader'

export function AppLayout() {
  return (
    <SidebarProvider>
      <div className="flex h-screen w-screen overflow-hidden">
        <AppSidebar />
        <SidebarInset className="flex flex-col min-w-0 flex-1">
          <AppHeader />
          <main className="flex-1 overflow-y-auto">
            <Outlet />
          </main>
        </SidebarInset>
      </div>
    </SidebarProvider>
  )
}
